// Página Tienda para e-commerce
// Muestra productos disponibles para apoyar el proyecto

import React from 'react';
import ProductList from '../../components/ecommerce/ProductList';

/**
 * Componente Tienda
 * 
 * Página principal de la tienda donde los usuarios pueden
 * comprar productos para apoyar el proyecto
 */
const Tienda = () => {
  return (
    <div className="">
      {/* Header de la página */}
      <div className="h-20 p-4 flex items-center justify-between border-b border-neutral-800 bg-neutral-900">
        <div>
          <h2 className="text-2xl font-bold text-white">
          Tienda
          </h2>
          <p className="text-neutral-400">
        Apoya el proyecto adquiriendo nuestros productos
          </p>
        </div>
      </div>
      

      {/* Lista de productos */}
      <ProductList />
    </div>
  );
};

export default Tienda;
